// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { previousMonday as fn } from "../previousMonday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const previousMondayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default previousMondayWithOptions;
